import TableText from "@/components/table/TableText";
import { Button, message, Row, Table, Spin, DatePicker, Select, Radio } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "../../../Auth";
import imgSave from "../../../saveImg";
import FileSaver from "file-saver";
import request from "@/method/request";
import compute, { setKarte } from "./compute";
import "./index.scss";

const { MonthPicker } = DatePicker;
const { Option } = Select

class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        lastdata: [],
        loading: true,
        loadingSave: false,
        print: false,
        dateData: [],
        area: "东南华南",
    }


    componentDidMount() {
        this.getData({ date: this.state.date, area: this.state.area });
    }


    getData = async ({ date, area, fullYear }) => {
        try {
            const year = moment(date).format('YYYY');
            const month = moment(date).format('M');
            const res = await request(`/_4_2_daily/fullRoom?year=${year}&month=${month}&area=${area}`);
            this.setState({ loading: false, data: compute(res.data || [], date) });
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
        }
    }


    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_2_2', 1.5, '4.22', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }
    downloadExcel = () => {
        const tableName = `区域满房报表`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_2_2_export').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }
    render() {
        const { print, loading, data, date, area } = this.state;
        console.log(data);
        const columnsMonth = new Array(moment(date).daysInMonth()).fill(1).reduce((a, b, i) => {
            return [...a, {
                title: `${date}-${i + 1}`,
                dataIndex: `m${i + 1}`,
                key: `m${i + 1}`,
                align: "center",
                width: 120,
                render: (text = 0, record, index) => {
                    const props = { text, index, type: 'percent', name: `m${i + 1}`, };
                    return <TableText data={props} />
                }
            }]
        }, []);
        const columns = [{
            title: 'Hotel',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 200,
            fixed: !print && "left",
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "name", };
                return <TableText data={props} />
            }
        },
        ...columnsMonth,
        {
            title: '满房天数',
            dataIndex: 'total',
            key: 'total',
            align: "center",
            width: 120,
            render: (text = 0, record, index) => {
                const props = { text, index, type: 'number', name: "total", };
                if (index == 33) props.type = '';
                return <TableText data={props} />
            }
        }];
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 table7_6 table4_2_summary" id="table4_2_2" style={{ height: 'auto' }}>
                    <Row className="title">
                        <Row>区域满房报表</Row>
                        <div className="title-select">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getData({ date: str, area })
                                }}
                            />
                            <Select
                                allowClear
                                defaultValue={area}
                                style={{ width: 200, marginLeft: 20 }}
                                onChange={(value) => {
                                    this.setState({
                                        data: [],
                                        loading: true,
                                        area: value
                                    }, () => {
                                        this.getData({ date, area: value })
                                    });
                                }}
                            >
                                <Option value="东南华南">东南华南</Option>
                                <Option value="华北华中">华北华中</Option>
                                <Option value="江浙沪皖">江浙沪皖</Option>
                                <Option value="西南">西南</Option>
                            </Select>
                        </div>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table4_2_2_export"
                            pagination={false}
                            className="content"
                            scroll={print ? {} : { y: 500, x: 1920 }}
                            rowKey={(record, index) => record.name}
                        />
                        <Button
                            type="primary"
                            style={{ float: 'right', marginTop: 20 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={print}
                        >导出Excel</Button>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/fullRoom/index.js